var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"content",class:_vm.status},[_vm._v(" "+_vm._s(_vm.remainingTime)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }